import { $, freeze, hasCookie } from '../utils/Utils';

const cookiespopup = (() => {
  const config = {
    get triggers() {
      return this.triggerCN
        .map(CN => [...document.querySelectorAll(`.${CN}`)])
        .reduce((acc, current) => [...acc, ...current]);
    },
    triggerCN: ['cookiespopup'],
    get pages() {
      return this.pageCN
        .map(CN => [...document.querySelectorAll(`.${CN}`)])
        .reduce((acc, current) => [...acc, ...current]);
    },
    pageCN: ['cookiespopup__page'],
    popup: $('.js-cookiespopup')[0], // The popup
    closeCN: 'js-close', // The popup close (approve)
    showCookiesCN: 'js-showcookies',
    showpageCN: 'cookiespopup__page--show',
    containerName: 'cookie_accept',
    body: $('body')[0], // The body
    bodyClassIgnores: ['error404'], // Pages that the popup shouldnt show on
    showCN: 'cookiespopup--show', // Class to be added on a popup that should be visible
    reloadOnSave: true, // If the page should reload on save
    freeze: false, // If the page should freeze
  };

  // Store the data in cookie or storage
  const store = () => {
    const now = new Date();
    now.setMonth(now.getMonth() + 1);

    // Set the cookie
    document.cookie = `${config.containerName
      }=true; expires=${now.toUTCString()}; path=/`;
  };

  // Save, hide the popup and possibly reload page
  const save = e => {
    store();
    config.popup.classList.remove(config.showCN);
    if (config.freeze) freeze.stop();
    e.preventDefault();
    if (config.reloadOnSave) window.location.reload();
  };

  // Show the popup
  const show = index => {
    if (config.freeze) freeze.start();
    config.popup.classList.add(config.showCN);
    config.pages[index].classList.add(config.showpageCN);
  };

  // Check Storage, If no cookie , initiate the form and show popup
  const checkStorage = (index = 0) => {
    if (
      config.popup.classList.contains(config.showCN) ||
      (!(document.cookie && hasCookie(config.containerName)) &&
        !config.bodyClassIgnores.some(className =>
          config.body.classList.contains(className),
        ))
    ) {
      show(index);
    }
  };

  // Build, setup the event listeners and such
  const build = () => {
    config.triggers.forEach(trigger => {
      trigger.querySelectorAll(`.${config.closeCN}`).forEach(closeBtn => {
        closeBtn.addEventListener('click', e => save(e));
      });

      checkStorage();
    });

    document
      .querySelectorAll(`.${config.showCookiesCN}`)
      .forEach(showCookiesBtn => {
        showCookiesBtn.addEventListener('click', () => show(1));
      });
  };

  // Init the popup
  const init = () => {
    if (config.triggers.length > 0) {
      build();
    }
  };

  return {
    init,
  };
})();

cookiespopup.init();
